export default "__VITE_ASSET__JmOf4RGA__"